export function getColorPickerFormikValueProps(field) {
  return { color: field.value }
}
